import { CovanceGridColumn, dateRenderer, dateTimeRenderer, dateTimeComparator, ViewHistoryAgRendererComponent, MulticellAgRendererComponent, MulticellParams, MulticellItem, MulticellTooltip } from '../../covance-ag-grid';
import { comparators } from '../../core';
import { ExternalUserEQuery } from '../models/external-user-e-query';
import { Injectable } from '@angular/core';

@Injectable()
export class ExternalUserEQueriesColumns {
    public viewHistory: CovanceGridColumn = {
        headerName: 'Read',
        field: 'viewHistory',
        width: 75,
        cellRendererFramework: ViewHistoryAgRendererComponent,
    };

    public eQueryId: CovanceGridColumn = {
        headerName: 'eQueryId',
        field: 'eQueryId',
        width: 90,
        comparator: (a, b) => comparators.numberComparator(a, b),
    };

    public status: CovanceGridColumn = {
        headerName: 'Status',
        field: 'eQueryStatus',
        width: 70,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    public visitName: CovanceGridColumn = {
        headerName: 'Visit',
        field: 'visitName',
        width: 120,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    public protocolVisitCode: CovanceGridColumn = {
        headerName: 'PVC',
        field: 'protocolVisitCode',
        width: 70,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    public visitCollectionDate: CovanceGridColumn = {
        headerName: 'Collected Date',
        field: 'visitCollectionDate',
        comparator: dateTimeComparator,
        valueGetter: (params: { data: ExternalUserEQuery }) => {
            if (!params.data) {
                return null;
            }
            return dateRenderer({ value: params.data.visitCollectionDate });
        },
    };

    public responseTime: CovanceGridColumn = {
        headerName: 'Response Time',
        field: 'responseTime',
        width: 100,
        comparator: dateTimeComparator,
        valueGetter: (params: { data: ExternalUserEQuery }) => {
            if (!params.data) {
                return null;
            }
            return dateTimeRenderer({ value: params.data.responseDateTime });
        },
    };
}
